import { Select } from '@/components/selects';
import { useUserInfo } from '@/features/userInfo/hooks';
import { useWorkspace } from '@/features/workspaces/hooks';
import { setCurrentWorkspace } from '@/features/workspaces/workspacesSlice';
import { useAppDispatch } from '@/reducers';
import { useHistory } from 'react-router-dom';

export const WorkspaceSelector = () => {
  const { workspaces } = useUserInfo();
  const dispatch = useAppDispatch();

  const formattedWorkspaceList = workspaces?.map((workspace) => ({
    id: workspace.id,
    label: workspace.name,
    doNotRenderValue: true,
  }));

  const currentWorkspace = useWorkspace();
  const history = useHistory();

  const activeWorkspace = formattedWorkspaceList?.find((workspace) => workspace.id === currentWorkspace.id);

  const handleWorkspaceChange = (item: any) => {
    const workspace = workspaces?.find((workspace) => workspace.id === item.id);
    if (workspace) {
      dispatch(setCurrentWorkspace(workspace));
      history.push('/home');
    }
  };

  return (
    <Select
      items={formattedWorkspaceList || []}
      placeholder='Workspace Selector'
      value={activeWorkspace}
      className='w-full bg-secondary-background font-semibold text-primary-900 hover:bg-gray-200 disabled:bg-secondary-background disabled:font-semibold disabled:text-primary-900'
      arrowClassName='text-primary-900'
      disabled={formattedWorkspaceList?.length === 1}
      isToShowArrow={formattedWorkspaceList?.length > 1 || false}
      onChange={handleWorkspaceChange}
    />
  );
};
